module.exports = __webpack_public_path__ + "static/media/hiddenIcon.d1ed31f4.svg";